import { useModalStateContext } from "../../../../contexts/ModalStateContext"
import DialogSolicitarCompraProduto from "../../../../screens/Estoque/components/MICompras/DialogSolicitarCompraProduto"
import DialogRegistrarRecebimentoMercadorias from "../../../../screens/Estoque/components/MIEntradaProdutos/DialogRegistrarRecebimentoMercadorias"
import { DialogListarCategorias } from "../../../../screens/Estoque/components/MIProdutos/Categoria/ListarCategorias"
import DialogCadastrarProduto from "../../../../screens/Estoque/components/MIProdutos/DialogCadastrarProduto"
import SolicitarRessuprimentoDialog from "../../../../screens/Estoque/components/SolicitarRessuprimentoDialog"
import { enqueueSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';
export default function ModaisEstoque() {

    const navigate = useNavigate()
    const { modais, handleToggleModal } = useModalStateContext()

    return (
        <>
            {modais.estoque.cadastrarProduto &&
                <DialogCadastrarProduto
                    open={modais.estoque.cadastrarProduto}
                    handleClose={() => handleToggleModal('estoque', 'cadastrarProduto', false)}
                />
            }
            {modais.estoque.listarCategorias &&
                <DialogListarCategorias
                    open={modais.estoque.listarCategorias}
                    handleClose={() => handleToggleModal('estoque', 'listarCategorias', false)}
                />
            }

            {modais.estoque.solicitarCompraProduto &&
                <DialogSolicitarCompraProduto
                    open={modais.estoque.solicitarCompraProduto}
                    onClose={() => handleToggleModal('estoque', 'solicitarCompraProduto', false)}
                />
            }
            {
                modais.estoque.entradaProdutosregistrarRecebimento &&
                <DialogRegistrarRecebimentoMercadorias
                    open={modais.estoque.entradaProdutosregistrarRecebimento}
                    handleClose={() => handleToggleModal('estoque', 'entradaProdutosregistrarRecebimento', false)}
                />
            }
            {modais.estoque.solicitarRessuprimento &&
                <SolicitarRessuprimentoDialog
                                    handleChangeProcesso={(item: string) => { }}
                                    open={modais.estoque.solicitarRessuprimento}
                                    handleClose={() => {
                                        handleToggleModal('estoque', 'solicitarRessuprimento', false)
                                    }}
                                    onCreate={(codigo: string) => {
                                        handleToggleModal('estoque', 'solicitarRessuprimento', false)
                                        enqueueSnackbar('Solicitação de ressuprimento #' + codigo + ' foi enviada com sucesso!' , { variant: 'success' });
                                        navigate("/estoque")
                                    }}
                                    onFail={() => {
                                        enqueueSnackbar("Erro ao criar solicitação de ressuprimento", {
                                            variant: "error"
                                        })
                                    }}
                                />
            }
        </>
    )
}
